module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"retry":"再試行","upload_failed":"アップロード失敗","ai_clothing_detected":"AI着用画像","ai_analyzing":"AI分析中..."}}')
  delete Component.options._Ctor
}
